<div class="form-container service-form">
  <div #fcomNotification *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR">
    <fcom-notification
      aria-live="polite"
      class="pr-small-y pr-clear-t mr-clear block"
      [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
      [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
    >
      {{
        (formStatus === FormStatus.ERROR ? 'SERVICE_FORMS.serviceForms.error.title' : 'plus.profile.updateSuccess')
          | finLocalization
      }}
    </fcom-notification>
  </div>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">{{
    'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
  }}</span>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" [finFormErrorFocus]="reactiveForm">
    <div
      *ngIf="formStatus === FormStatus.INITIAL || formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR"
    >
      <div class="flex flex--row flex--wrap form-subgroup" *ngIf="reactiveForm.get('type').enabled">
        <fcom-radio-item-group
          [options]="[{ value: LoginAddressType.HOME }, { value: LoginAddressType.JOB }]"
          [parentForm]="reactiveForm"
          [controlName]="'type'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.mailingAddressType'"
        >
        </fcom-radio-item-group>
      </div>
      <div
        class="flex flex--row flex--wrap form-subgroup"
        [ngClass]="{ 'is-hidden': reactiveForm.get('type').value !== LoginAddressType.HOME }"
        *ngIf="reactiveForm.get('homeAddress') as homeAddressForm"
      >
        <fin-form-input-select
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.COUNTRY"
          [options]="countries$ | async"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.country'"
          (change)="onCountrySelect(homeAddressForm.get(MailingAddressFormField.COUNTRY).value)"
        ></fin-form-input-select>
        <fin-form-input-select
          *ngIf="
            homeAddressForm.get(MailingAddressFormField.STATE_OR_PROVINCE).enabled &&
            selectedCountryText[homeAddressForm.get(MailingAddressFormField.COUNTRY).value]
          "
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.STATE_OR_PROVINCE"
          [options]="selectedCountryText[homeAddressForm.get(MailingAddressFormField.COUNTRY).value].options | async"
          [translationPrefix]="
            selectedCountryText[homeAddressForm.get(MailingAddressFormField.COUNTRY).value].translation
          "
        ></fin-form-input-select>
        <fin-form-input-text
          *ngIf="
            homeAddressForm.get(MailingAddressFormField.BUILDING_NAME_OR_PREFECTURE).enabled &&
            selectedCountryText[homeAddressForm.get(MailingAddressFormField.COUNTRY).value]
          "
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.BUILDING_NAME_OR_PREFECTURE"
          [translationPrefix]="
            selectedCountryText[homeAddressForm.get(MailingAddressFormField.COUNTRY).value].translation
          "
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.STREET_ADDRESS"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.streetAddress'"
          (change)="onValueChange(homeAddressForm, MailingAddressFormField.STREET_ADDRESS)"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.POSTAL_CODE"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.postalCode'"
          (change)="onValueChange(homeAddressForm, MailingAddressFormField.POSTAL_CODE)"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="homeAddressForm"
          [controlName]="MailingAddressFormField.CITY"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.city'"
          (change)="onValueChange(homeAddressForm, MailingAddressFormField.CITY)"
        ></fin-form-input-text>
      </div>
      <div
        class="flex flex--row flex--wrap form-subgroup"
        [ngClass]="{ 'is-hidden': reactiveForm.get('type').value !== LoginAddressType.JOB }"
        *ngIf="reactiveForm.get('workAddress').value && reactiveForm.get('workAddress') as workAddressForm"
      >
        <fin-form-input-text
          *ngIf="workAddressForm.get(MailingAddressFormField.COMPANY_NAME).enabled"
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.COMPANY_NAME"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.companyName'"
        ></fin-form-input-text>
        <fin-form-input-select
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.COUNTRY"
          [options]="countries$ | async"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.country'"
          (change)="onCountrySelect(workAddressForm.get(MailingAddressFormField.COUNTRY).value)"
        ></fin-form-input-select>
        <fin-form-input-select
          *ngIf="
            workAddressForm.get(MailingAddressFormField.STATE_OR_PROVINCE).enabled &&
            selectedCountryText[workAddressForm.get(MailingAddressFormField.COUNTRY).value]
          "
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.STATE_OR_PROVINCE"
          [options]="selectedCountryText[workAddressForm.get(MailingAddressFormField.COUNTRY).value].options | async"
          [translationPrefix]="
            selectedCountryText[workAddressForm.get(MailingAddressFormField.COUNTRY).value].translation
          "
        ></fin-form-input-select>
        <fin-form-input-text
          *ngIf="
            workAddressForm.get(MailingAddressFormField.BUILDING_NAME_OR_PREFECTURE).enabled &&
            selectedCountryText[workAddressForm.get(MailingAddressFormField.COUNTRY).value]
          "
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.BUILDING_NAME_OR_PREFECTURE"
          [translationPrefix]="
            selectedCountryText[workAddressForm.get(MailingAddressFormField.COUNTRY).value].translation
          "
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.STREET_ADDRESS"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.streetAddress'"
          (change)="onValueChange(workAddressForm, MailingAddressFormField.STREET_ADDRESS)"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.POSTAL_CODE"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.postalCode'"
          (change)="onValueChange(workAddressForm, MailingAddressFormField.POSTAL_CODE)"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="workAddressForm"
          [controlName]="MailingAddressFormField.CITY"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.city'"
          (change)="onValueChange(workAddressForm, MailingAddressFormField.CITY)"
        ></fin-form-input-text>
      </div>
    </div>
    <div class="ps-small-t mr-xxsmall-r" [ngClass]="{ 'align-left': enableCancel, 'align-right': !enableCancel }">
      <fcom-button
        *ngIf="enableCancel"
        [disabled]="formStatus === FormStatus.LOADING"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [text]="'SERVICE_FORMS.serviceForms.cancel' | finLocalization"
        (clickBtn)="onCancel()"
      ></fcom-button>
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.save' | finLocalization"
      ></fcom-button>
    </div>
  </form>
</div>
